import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';

export const Dropdown = ({ grid, options, onChange, value, question }) => (
  <Grid alignItems="center" container item xs={grid || 12}>
    <Grid item xs={12} lg={5}>
      <span>{question}</span>
    </Grid>
    <Grid item xs={12} lg={7}>
      <FormControl sx={{ minWidth: 200, maxWidth: '100%' }}>
        <InputLabel id="select-auto-width-label">Select</InputLabel>
        <Select
          label="Select"
          size="small"
          value={value}
          onChange={({ target: { value } }) => onChange(value)}
        >
          <MenuItem value="">None</MenuItem>
          {options.split('\n').map((el) => (
            <MenuItem key={el} value={el}>
              {el}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  </Grid>
);
